/* src/app/components/controls/proXSign/pxs-check-version/pxs-check-version.component.css */
.pxs-ready {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  flex-wrap: wrap;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  margin: 16px 0;
}
.pxs-ready-icon {
  color: #16a34a;
  flex-shrink: 0;
}
.pxs-ready-text {
  font-size: 13px;
  color: #475569;
}
.pxs-ready-cert {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}
.pxs-ready-spacer {
  flex: 1;
}
.pxs-ready-sep {
  width: 1px;
  height: 14px;
  background: #cbd5e1;
}
.pxs-ready-link {
  font-size: 13px;
  color: #3b82f6;
  cursor: pointer;
  font-weight: 500;
}
.pxs-ready-link:hover {
  text-decoration: underline;
}
.pxs-alert {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: #fef3f2;
  border: 1px solid #fecdca;
  border-radius: 10px;
  padding: 20px 24px;
  margin: 16px 0;
}
.pxs-alert-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #fee4e2;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d92d20;
}
.pxs-alert-content {
  flex: 1;
  min-width: 0;
}
.pxs-alert-title {
  font-size: 15px;
  font-weight: 500;
  color: #b42318;
  margin: 0 0 6px 0;
}
.pxs-alert-text {
  font-size: 13px;
  color: #7a271a;
  margin: 0 0 4px 0;
  line-height: 1.5;
}
.pxs-alert-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 8px 16px;
  background: #fff;
  border: 1px solid #fecdca;
  border-radius: 8px;
  color: #b42318;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.15s;
  cursor: pointer;
}
.pxs-alert-link:hover {
  background: #fef3f2;
}
/*# sourceMappingURL=pxs-check-version.component.css.map */
